export default {
  setCounter(state, counter) {
    state.counter = counter;
  },
  setIsCountDowning(state, isCountDowning) {
    state.isCountDowning = isCountDowning;
  },
  setCoundownSec(state, sec) {
    state.countDownSec = sec;
  },
};
